import { render, staticRenderFns } from "./CmgLoyaltyQuestions.vue?vue&type=template&id=2aa01ab0&scoped=true&lang=pug&"
import script from "./cmg-loyalty-questions.ts?vue&type=script&lang=ts&"
export * from "./cmg-loyalty-questions.ts?vue&type=script&lang=ts&"
import style0 from "./CmgLoyaltyQuestions.vue?vue&type=style&index=0&id=2aa01ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa01ab0",
  null
  
)

export default component.exports